import { createSlice,createAsyncThunk } from '@reduxjs/toolkit'
import {getZonas, addEditZona, delZona, inactivateZona} from '../../services';
import historyHelper from "../../helpers/history";
import {IZona, IZonaState} from "../types/IZona";

const initialState: IZonaState = {
    status: "idle",
    list:[]
}

export const mostrarZonas = createAsyncThunk(
    'mostrarZonas', async (filter:any = {}) => {

        const response = await getZonas(filter)
        return {data:response.data as IZona[], params: response.config.params}
    }
)
export const agregarEditarZona = createAsyncThunk(
    'zonas/agregarEditar', async (zona: IZona) => {
        const response = await addEditZona(zona);

        if (response.status === 200) {
            historyHelper.back();
        }
        return {data: response.data, edit:!!zona.id};
    }
);
export const eliminarZona = createAsyncThunk(
    'zonas/eliminar', async (id: number) => {
        await delZona(id);
        return id;
    }
);
export const inactivarZona = createAsyncThunk(
    'zona/inactivar', async (id: number) => {
        const response = await inactivateZona(id);
        if (response.status === 200 || response.status === 204) {
            historyHelper.replace("/zonas")
        }
        return id;
    }
);
const slice = createSlice({
    name: 'mostrarZonas',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarZonas
        builder.addCase(mostrarZonas.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarZonas.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarZonas.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarZona
        builder.addCase(agregarEditarZona.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarZona.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list = state.list?.filter(e => e.id !== action.payload.data.id);
                state.list.unshift(action.payload.data);
            }
        })
        builder.addCase(agregarEditarZona.rejected, (state ) => {
            state.status = "idle";
        })

        //--eliminarZona
        builder.addCase(eliminarZona.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarZona.fulfilled, (state,action ) => {
            state.status = "idle";

            const id = action.payload;
            if(state.list){
                state.list = state.list?.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarZona.rejected, (state ) => {
            state.status = "idle";
        })
        // inactivarZona
        builder.addCase(inactivarZona.fulfilled, (state,action ) => {
            state.status = "idle";

            const id  = action.payload;
            if(state.list){
                state.list = state.list?.map(item => {
                    if(item.id === id){
                        return {...item, inactivo: !item.inactivo}
                    }
                    return item
                });
            }
        })


    }

});


export default slice.reducer;
